import { SET_ART_WALL_CANVAS_HEIGHT } from './../const';

export default (artWallCanvasHeight) => {
  return {
    type: SET_ART_WALL_CANVAS_HEIGHT,
    artWallCanvasHeight: artWallCanvasHeight
  }
};
